<template>
    <div class="page__content">
        <StoryblokComponent
            v-for="(blok, index) in story.content.body"
            :key="blok._uid"
            :story="story"
            :blok="blok"
            :priority="index === 0"
        />
    </div>
</template>

<script setup>
const runtimeConfig = useRuntimeConfig()

const { data: story } = await useAsyncData('page-home', () => $fetch('/api/page?full_slug=home'))
const { data: config } = await useConfig()

useHead({
    // Deliberately no seoTitle() fallback: the homepage leaves meta_title empty
    // so titleTemplate emits the bare brand name.
    title: story.value.content.meta_title,
    meta: [
        {
            hid: 'description',
            name: 'description',
            content: story.value.content.meta_description,
        },
    ],
})

const organizationSchema = {
    '@context': 'https://schema.org',
    '@type': 'OnlineBusiness',
    'url': `${runtimeConfig.public.BASE_URL}/`,
    'logo': config.value.schema_logo.filename,
    'name': config.value.schema_name,
    'description': config.value.schema_description,
    'foundingDate': config.value.founding_date,
    'numberOfEmployees': {
        '@type': 'QuantitativeValue',
        'value': config.value.number_of_employees,
    },
}

const searchSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    'name': config.value.schema_name,
    'url': runtimeConfig.public.BASE_URL,
    'potentialAction': {
        '@type': 'SearchAction',
        'target': {
            '@type': 'EntryPoint',
            'urlTemplate': `${runtimeConfig.public.BASE_URL}/search?search={search_term_string}`,
        },
        'query-input': 'required name=search_term_string',
    },
}

useSchemaOrg([
    organizationSchema,
    searchSchema,
])

useHead({
    meta: [
        ...(config.value.meta_image
            ? [{
                    property: 'og:image',
                    content: `${config.value.meta_image.filename}/m/1200x630`,
                }]
            : []),
    ],
})
</script>
